interface Props {
  page: number;
  total: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, total, onChange }: Props) {
  if (total <= 1) return null;
  const pages = Array.from({ length: total }, (_, i) => i + 1);
  const baseBtn =
    "inline-flex items-center justify-center min-w-[40px] h-10 px-3 rounded-md border text-sm font-medium transition-colors cursor-pointer whitespace-nowrap";
  return (
    <nav aria-label="分页" className="flex items-center justify-center gap-2 pt-2 flex-wrap">
      <button
        type="button"
        disabled={page <= 1}
        onClick={() => onChange(page - 1)}
        className={`${baseBtn} ${
          page <= 1
            ? "border-background-200 text-foreground-400 cursor-not-allowed"
            : "border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-700"
        }`}
      >
        <i className="ri-arrow-left-s-line" /> 上一页
      </button>
      {pages.map((p) => (
        <button
          key={p}
          type="button"
          onClick={() => onChange(p)}
          aria-current={p === page ? "page" : undefined}
          className={`${baseBtn} ${
            p === page
              ? "border-primary-500 bg-primary-500 text-foreground-950"
              : "border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-700"
          }`}
        >
          {p}
        </button>
      ))}
      <button
        type="button"
        disabled={page >= total}
        onClick={() => onChange(page + 1)}
        className={`${baseBtn} ${
          page >= total
            ? "border-background-200 text-foreground-400 cursor-not-allowed"
            : "border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-700"
        }`}
      >
        下一页 <i className="ri-arrow-right-s-line" />
      </button>
    </nav>
  );
}